/**
 * 2022-02-13
 * origin: https://app.zeplin.io/project/614bed834869303d4a4096e4/screen/61dc3caba7a65728a5d0f923
 * icon卖点组件之No.5
 */
import css from './index.module.scss';
import { TextModule } from '@/components/ProductDetailComponents';
import EFBlueTick from '@/components/UI/svg/Icons/EFBlueTick';

const defaultData = {
    title1: { text: 'LFP Battery Chemistry + BMS' },
    title2: { text: 'A battery built to last' },
    items: [
        {
            text: 'EV station charging. That’s a world first. ',
            icon: <EFBlueTick />,
        },
        {
            text: 'Solar charging. Faster than ever. ',
            icon: <EFBlueTick />,
        },
        {
            text: 'We’re making a wind turbine too. ',
            icon: <EFBlueTick />,
        },
        {
            text: 'The world’s fastest wall charge. ',
            icon: <EFBlueTick />,
        },
        {
            text: 'Top up on-the-go. ',
            icon: <EFBlueTick />,
        },
        {
            text: 'Just when you thought you were out of options. ',
            icon: <EFBlueTick />,
        },
    ],
};

const defaultStyle = {
    backColor: '#fff',
    height: 'auto',
    title1Style: { type: 'ls', width: '540px' },
    title2Style: { type: 'ls', color: '#919191', width: '540px' },
    textIconStyle: {
        type: 'sl',
        fontFamily: 'var(--font-family-Medium)',
        iconMargin: '28px',
        color: '#03060b',
        fontWeight: 700,
        lineHeight: '30px',
        width: '432px',
    },
};

export default function Fourth({ data = defaultData, cssStyle = defaultStyle }: any) {
    const { title1, title2, items } = {
        title1: { ...defaultData.title1, ...data.guide },
        title2: { ...defaultData.title2, ...data.title },
        items: data.items,
    };
    cssStyle.title1Style = {
        ...defaultStyle.title1Style,
        ...{ backColor: cssStyle.backColor },
        ...cssStyle.title1Style,
    };
    cssStyle.title2Style = {
        ...defaultStyle.title2Style,
        ...{ backColor: cssStyle.backColor },
        ...cssStyle.title2Style,
    };
    cssStyle.textIconStyle = {
        ...defaultStyle.textIconStyle,
        ...{ backColor: cssStyle.backColor },
        ...cssStyle.textIconStyle,
    };
    const { backColor, height, title1Style, title2Style, textIconStyle } = cssStyle;

    return (
        <div className={`${css.sellPointsModule} sellPointsModuleFifth`} style={{ background: backColor, height: height }}>
            <div className="container">
                <div className="leftPart">
                    <TextModule cssStyle={title1Style} data={title1} />
                    <TextModule cssStyle={title2Style} data={title2} />
                </div>
                <div className="rightPart">
                    <ul className="sellLists">
                        {items.map((item: any, i: number) => (
                            <li className="list" key={i} style={{ marginTop: i === 0 ? 0 : '20px' }}>
                                <TextModule data={item} cssStyle={textIconStyle} />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
